import Vue from 'vue';
import VueRouter from 'vue-router';
import Meta from 'vue-meta';

Vue.use(VueRouter);
Vue.use(Meta, {
  keyName: 'metaInfo',
  refreshOnceOnNavigation: true,
});

const aboutRoutes = [
  {
    path: '/sobre/aeureciclo',
    name: 'about',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/About/About.vue'),
  },
  {
    path: '/sobre/nossa-solucao',
    name: 'our-solutions',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/About/OurSolutions.vue'),
  },
  {
    path: '/sobre/selo',
    name: 'stamp',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/About/Stamp.vue'),
  },
  {
    path: '/sobre/greenprint',
    name: 'greenprint',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/About/Greenprint.vue'),
  },
  {
    path: '/sobre/faq',
    name: 'faq',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/About/Faq.vue'),
  },
];

const casesRoutes = [
  {
    path: '/marcas/cases/joy',
    name: 'joy-case',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/Cases/Joy.vue'),
  },
  {
    path: '/marcas/cases/arezzo',
    name: 'arezzo-case',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/Cases/Arezzo.vue'),
  },
  {
    path: '/marcas/cases/lola',
    name: 'lola-case',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/Cases/Lola.vue'),
  },
  {
    path: '/marcas/cases/maismu',
    name: 'maismu-case',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/Cases/MaisMu.vue'),
  },
  {
    path: '/marcas/cases/vidaveg',
    name: 'vidaveg-case',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/Cases/VidaVeg.vue'),
  },
  {
    path: '/marcas/cases/p&g',
    name: 'p&g-case',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/Cases/P&g.vue'),
  },
  {
    path: '/marcas/cases/qualy',
    name: 'qualy-case',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/Cases/Qualy.vue'),
  },
];

const filesRoutes = [
  {
    path: '/material/manual-da-marca',
    name: 'manual-da-marca',
    meta: { layout: 'clean', mode: 'dark' },
    props: {
      // fileName: require('@/assets/files/termsofuse/manual-do-selo-eureciclo.pdf'),
      fileURL: '/material/manual-do-selo-eureciclo.pdf',
    },
    component: () => import('../views/BrandManual.vue'),
  },
  {
    path: '/material/ebook-como-criar-mundo-sem-lixo',
    meta: { layout: 'clean', mode: 'dark' },
    component: () => import('../views/BrandManual.vue'),
    props: {
      // fileName: require('@/assets/files/ebook-como-criar-mundo-sem-lixo.pdf'),
      fileURL: '/material/ebook-como-criar-mundo-sem-lixo.pdf',
    },
  },
  {
    path: '/material/relatorio-desempenho-eureciclo-2020',
    meta: { layout: 'clean', mode: 'dark' },
    component: () => import('../views/BrandManual.vue'),
    props: {
      // fileName: require('@/assets/files/relatorio-de-desempenho-eureciclo-2020.pdf'),
      fileURL: '/material/relatorio-de-desempenho-eureciclo-2020.pdf',
    },
  },
  {
    path: '/material/case-sustentabilidade-empresas-raymundo-da-fonte',
    meta: { layout: 'clean', mode: 'dark' },
    component: () => import('../views/BrandManual.vue'),
    props: {
      // fileName: require('@/assets/files/relatorio-de-desempenho-eureciclo-2020.pdf'),
      fileURL: '/material/case-sustentabilidade-empresas-raymundo-da-fonte.pdf',
    },
  },
  {
    path: '/material/performance-report-eureciclo-2020',
    meta: { layout: 'clean', mode: 'dark' },
    component: () => import('../views/BrandManual.vue'),
    props: {
      // fileName: require('@/assets/files/relatorio-de-desempenho-eureciclo-2020.pdf'),
      fileURL: '/material/performance-report-eureciclo-2020.pdf',
    },
  },
  {
    path: '/codigo-de-conduta',
    meta: { layout: 'clean', mode: 'dark' },
    component: () => import('../views/BrandManual.vue'),
    props: {
      fileURL: '/material/codigo-de-conduta-eureciclo.pdf',
    },
  },
  {
    path: '/politica-socioambiental-e-de-governanca-corporativa-ESG',
    meta: { layout: 'clean', mode: 'dark' },
    component: () => import('../views/BrandManual.vue'),
    props: {
      fileURL:
        '/material/politica-socioambiental-e-de-governanca-corporativa-eureciclo-ESG.pdf',
    },
  },
  {
    path: '/codigo-de-etica',
    meta: { layout: 'clean', mode: 'dark' },
    component: () => import('../views/BrandManual.vue'),
    props: {
      fileURL: '/material/codigo-de-etica-eureciclo.pdf',
    },
  },
  {
    path: '/codigo-de-principios-de-negocios',
    meta: { layout: 'clean', mode: 'dark' },
    component: () => import('../views/BrandManual.vue'),
    props: {
      fileURL: '/material/codigo-de-principios-de-negocios-eureciclo.pdf',
    },
  },
  {
    path: '/politica-de-compliance',
    meta: { layout: 'clean', mode: 'dark' },
    component: () => import('../views/BrandManual.vue'),
    props: {
      fileURL: '/material/politica-de-compliance-eureciclo.pdf',
    },
  },
];

const lpsRoutes = [
  {
    path: '/lp/saopaulo',
    name: 'lp-saopaulo',
    meta: { layout: 'content', mode: 'dark', hideNav: true, hideFooter: true },
    component: () => import('../views/Lps/LpSaoPaulo.vue'),
  },
  {
    path: '/descarbonizacao-reciclagem',
    name: 'descarbonizacao-reciclagem',
    meta: { layout: 'content', mode: 'dark', hideNav: true },
    component: () => import('../views/Lps/DescarbonizacaoReciclagem.vue'),
  },
  {
    path: '/lp',
    name: 'lp-demo',
    meta: { layout: 'content', hideFooter: true },
    component: () => import('../views/Lps/ClientBaseLp/Index.vue'),
  },
  {
    path: '/relatorio-de-desempenho',
    name: 'relatorio-de-desempenho-2022',
    meta: { layout: 'performance-report', mode: 'dark' },
    component: () => import('../views/PerformanceReport/Index.vue'),
  },
  {
    path: '/relatorio-de-desempenho/2021',
    name: 'relatorio-de-desempenho-2021',
    meta: { layout: 'performance-report', mode: 'dark' },
    component: () => import('../views/PerformanceReport/2021.vue'),
  },
  {
    path: '/oqbebidassaudaveis',
    name: 'oqbebidassaudaveis',
    meta: { layout: 'content', hideFooter: true },
    component: () => import('../views/OqBebidasSaudaveis.vue'),
  },
  {
    path: '/burle',
    name: 'burle',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/OndaCircular.vue'),
  },
  {
    path: '/onda-circular',
    name: 'onda-circular',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/OndaCircular.vue'),
  },
  {
    path: '/lp-legislacao',
    name: 'lp-legislacao',
    meta: { layout: 'legislation-lp', mode: 'dark' },
    component: () => import('../views/LegislationLP.vue'),
  },
  {
    path: '/cmo',
    name: 'cmo',
    meta: { layout: 'content', mode: 'dark', hideNav: true, hideFooter: true },
    component: () => import('../views/CmoSummit.vue'),
  },
  {
    path: '/rede-transforma',
    name: 'rede-transforma',
    meta: { layout: 'content', mode: 'dark', hideNav: true, hideFooter: true },
    component: () => import('../views/Lps/RedeTransforma.vue'),
  },
  {
    path: '/case-ecocooperativa',
    name: 'case-ecocooperativa',
    meta: { layout: 'content', mode: 'dark', hideNav: true, hideFooter: true },
    component: () => import('../views/Lps/CaseEcocooperativa.vue'),
  },
  {
    path: '/case-cooperativa-filadelphia',
    name: 'case-cooperativa-filadelphia',
    meta: { layout: 'content', mode: 'dark', hideNav: true, hideFooter: true },
    component: () => import('../views/Lps/CaseCooperativaFiladelphia.vue'),
  },
  {
    path: '/setor-bebidas',
    name: 'setor-bebidas',
    meta: { layout: 'content', mode: 'dark', hideNav: true, hideFooter: true },
    component: () => import('../views/Lps/SetorBebidas.vue'),
  },
  {
    path: '/setor-alimentos',
    name: 'setor-alimentos',
    meta: { layout: 'content', mode: 'dark', hideNav: true, hideFooter: true },
    component: () => import('../views/Lps/SetorAlimentos.vue'),
  },
  {
    path: '/solucoes-eureciclo',
    name: 'solucoes-eureciclo',
    meta: { layout: 'content', mode: 'dark', hideFooter: true },
    component: () => import('../views/Lps/SolucoesEureciclo.vue'),
  },
];

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      backgroundImage: require('@/assets/images/landing/banner.jpg'),
      layout: 'home',
    },
    component: () => import('../views/Index.vue'),
  },
  {
    path: '/c/:keycode',
    name: 'stamp-certification',
    meta: { layout: 'clean' },
    beforeEnter: to => {
      const { keycode } = to.params;
      window.location.replace(`https://legacy.eureciclo.com.br/c/${keycode}`);
    },
  },
  {
    path: '/empreendedores',
    name: 'small-companies',
    meta: {
      backgroundImage: require('@/assets/images/small-companies/banner.jpg'),
      name: 'Empreendedor',
      layout: 'content',
    },
    component: () => import('../views/SmallCompanies.vue'),
  },
  {
    path: '/contato',
    name: 'contact',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/Contact.vue'),
  },
  {
    path: '/nossos-precos',
    name: 'our-prices',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/OurPrices.vue'),
    beforeEnter() {
      window.location.href = 'https://checkout-ms.eureciclo.io/checkout/prices';
    },
  },
  {
    path: '/corporacoes',
    name: 'corporations',
    meta: {
      backgroundImage: require('@/assets/images/corporations/banner.jpg'),
      name: 'Corporação',
      layout: 'content',
    },
    component: () => import('../views/Corporations.vue'),
  },
  {
    path: '/operadores',
    redirect: '/centrais-de-triagem',
  },
  {
    path: '/centrais-de-triagem',
    name: 'recycling-operators',
    meta: {
      backgroundImage: require('@/assets/images/operators/banner.jpg'),
      name: 'Centrais de triagem',
      layout: 'content',
    },
    component: () => import('../views/RecyclingOperators.vue'),
  },
  {
    path: '/consumidores',
    name: 'consumers',
    meta: {
      backgroundImage: require('@/assets/images/consumers/banner.jpg'),
      name: 'Consumidor',
      layout: 'content',
    },
    component: () => import('../views/Consumers.vue'),
  },
  {
    path: '/consultores',
    name: 'consultores',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/About/Consultors.vue'),
  },
  {
    path: '/trabalhe-conosco',
    name: 'jobs',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/About/Jobs.vue'),
  },
  {
    path: '/trabalhe-conosco/vaga/:slug',
    name: 'vacancy',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/About/Vacancy.vue'),
  },
  {
    path: '/trabalhe-conosco/vaga/',
    redirect: '/trabalhe-conosco',
  },
  {
    path: '/associacoes',
    name: 'associations',
    meta: {
      layout: 'content',
      backgroundImage: require('@/assets/images/associations/banner.jpg'),
      name: 'Associação',
    },
    component: () => import('../views/Associations.vue'),
  },
  {
    path: '/marcas',
    name: 'brands',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/Brands.vue'),
  },
  {
    path: '/marcas/cases',
    name: 'view-cases',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/ViewCases.vue'),
  },
  {
    path: '/aprenda/ebook-guias-e-mais',
    name: 'newsletters',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/FreeContent.vue'),
  },
  {
    path: '/leis-e-decretos',
    name: 'leis-e-decretos',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/Laws.vue'),
  },
  {
    path: '/checkout',
    name: 'checkout',
    meta: { layout: 'checkout', mode: 'dark' },
    component: () => import('../views/Checkout.vue'),
    beforeEnter() {
      window.location.href = 'https://checkout-ms.eureciclo.io/checkout/prices';
    },
  },
  {
    path: '/marca/oxplants',
    name: 'resultados-oxplants',
    meta: { layout: 'clean', mode: 'dark' },
    component: () => import('../views/ResultsFlora.vue'),
  },
  {
    path: '/marca/datwyler',
    name: 'resultados-datwyler',
    meta: { layout: 'clean', mode: 'dark' },
    component: () => import('../views/ResultsDatwyler.vue'),
  },
  {
    path: '/termos-e-condicoes',
    name: 'termos-e-condicoes',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/TermsOfUse.vue'),
  },
  {
    path: '/politica-de-privacidade',
    name: 'politica-de-privacidade',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  ...aboutRoutes,
  ...casesRoutes,
  ...filesRoutes,
  ...lpsRoutes,
  {
    path: '*',
    meta: { layout: 'content', mode: 'dark' },
    component: () => import('../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 }),
});

/**
 * Creates a pages info to populate sitemap.xml file
 */

// function getRoutesList(_routes, pre) {
//   return _routes.reduce((array, route) => {
//     const path = `${pre}${route.path}`;

//     if (route.path !== '*') {
//       array.push(path);
//     }

//     if (route.children) {
//       array.push(...getRoutesList(route.children, `${path}/`));
//     }

//     return array;
//   }, []);
// }

// function getRoutesXML() {
//   const list = getRoutesList(
//     router.options.routes,
//     'https://www.eureciclo.com.br',
//   )
//     .map(route => `<url><loc>${route}</loc></url>`)
//     .join('\r\n');
//   return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
//   ${list}
// </urlset>`;
// }

// if (process.env.NODE_ENV !== 'production') {
//   console.log(getRoutesXML());
// }

export default router;
